var _String={count:function(t,n){var r=t.split(n);return r.length-1}};module.exports=_String;